import React from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function AdminLogin() {
    const { user, login } = useAuth();
    const navigate = useNavigate();
    const [form, setForm] = React.useState({ email: "", password: "" });
    const [error, setError] = React.useState("");
    const [loading, setLoading] = React.useState(false);

    if (user && user.role === "admin") {
        return <Navigate to="/admin" replace />;
    }

    const submit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        try {
            await login(form.email, form.password);
            navigate("/admin");
        } catch (err) {
            const detail = err?.response?.data?.detail;
            setError(typeof detail === "string" ? detail : "Connexion impossible");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div data-testid="page-admin-login" className="min-h-screen flex items-center justify-center px-6">
            <form onSubmit={submit} className="w-full max-w-md bg-[#0f0f0f] border border-white/10 p-10">
                <p className="text-xs uppercase tracking-[0.3em] text-[#c5a059] mb-3">Espace privé</p>
                <h1 className="font-serif-display text-4xl mb-8">Connexion admin</h1>

                <label className="block mb-5">
                    <span className="text-xs uppercase tracking-[0.22em] text-zinc-400">Email</span>
                    <input
                        data-testid="admin-login-email"
                        type="email"
                        required
                        value={form.email}
                        onChange={(e) => setForm({ ...form, email: e.target.value })}
                        className="mt-2 w-full bg-transparent border border-white/15 text-white px-4 py-3 focus:border-[#c5a059] outline-none"
                    />
                </label>

                <label className="block mb-6">
                    <span className="text-xs uppercase tracking-[0.22em] text-zinc-400">Mot de passe</span>
                    <input
                        data-testid="admin-login-password"
                        type="password"
                        required
                        value={form.password}
                        onChange={(e) => setForm({ ...form, password: e.target.value })}
                        className="mt-2 w-full bg-transparent border border-white/15 text-white px-4 py-3 focus:border-[#c5a059] outline-none"
                    />
                </label>

                {error && (
                    <p data-testid="admin-login-error" className="text-red-400 text-sm mb-4">{error}</p>
                )}

                <button
                    data-testid="admin-login-submit"
                    type="submit"
                    disabled={loading}
                    className="w-full bg-[#c5a059] text-black font-medium py-3 uppercase tracking-[0.2em] text-sm hover:bg-[#dcc082] transition-colors disabled:opacity-50"
                >
                    {loading ? "Connexion…" : "Se connecter"}
                </button>
            </form>
        </div>
    );
}
